// extracted by mini-css-extract-plugin
module.exports = {"header":"TeamHeader_header__3El0s"};